import { atom } from 'jotai';
import { UserPosts } from 'shared/models';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { $UserPost } from 'shared/atoms';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $UserPostLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom(null, async (get, set, input: PromiseOrValue<UserPosts>) => {
    const awaitOld = await get($UserPost(userLinkName));
    const awaitedInput = await input;

    const oldGroupIds = new Set(awaitOld.items.map((item) => item.groupId));
    const items = awaitOld.items.concat(awaitedInput.items.filter((item) => !oldGroupIds.has(item.groupId)));

    set($UserPost(userLinkName), {
      ...input,
      items,
    });
  });

  a.debugLabel = `$UserPostLoadmore+${encodeURIComponent(userLinkName)}`;

  return a;
});
